<template>
    <edit-dialog title="设置授权日期" :show="show" @close="onClose" width="500px">
        <el-form :model="modelData" label-width="100px" :rules="validRules" ref="frm">
            <el-form-item prop="authDate" label="授权日期">
                <el-date-picker v-model="modelData.authDate" type="date" placeholder=""> </el-date-picker>
            </el-form-item>
        </el-form>
        <template v-slot:button>
            <el-button type="success" @click="saveData"> 保存 </el-button>
            <el-button type="info" @click="onClose"> 取消 </el-button>
        </template>
    </edit-dialog>
</template>

<script>
export default {
    components: {},
    name: "SetAuthDate",
    data() {
        return {
            modelData: {
                authDate: "",
            },
            validRules: {
                authDate: [
                    {
                        required: true,
                        message: "请选择授权日期",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.modelData = { ...this.data };
    },
    props: {
        show: { type: Boolean, default: false },
        data: {
            type: Object,
        },
    },
    methods: {
        onClose() {
            this.$emit("close");
        },
        saveData() {
            this.$refs.frm.validate((r) => {
                if (r) {
                    this.$emit("save", this.modelData);
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.inputText {
    width: 220px;
}
</style>
